import { FC } from "react";
import { ICustomDotProps } from "./types";



const CustomDot: FC<ICustomDotProps> = ({
  cx,
  cy,
  payload,
  fillColor,
  isHover,
  onClickDot,
  onTooltipShow,
  onTooltipHide,
  activeDotPayload,
  dataKey,
}) => {
  if (!payload) {
    return null
  };
  const { visibility, sentiment, ranking, empty, created_at, isLast } = payload;
  const isActive = isHover || (activeDotPayload && activeDotPayload.created_at === created_at);

  if ( 
    (dataKey === 'visibility' && visibility === null) || 
    (dataKey === 'sentiment' && sentiment === null) || 
    (dataKey === 'ranking' && ranking === null) || 
    !cx || !cy || empty || 
    (!isActive && !isLast)
  ) {
    return null;
  }

  const handleMouseEnter = () => {
    if (!onTooltipShow || !cx || !cy) return;
    onTooltipShow(cx + 25, cy - 70, payload);
  };

  const handleMouseLeave = () => {
    if (onTooltipHide) {
      onTooltipHide();
    }
  };

  const handleClick = (e: React.MouseEvent<SVGCircleElement>) => {
    e.stopPropagation();
    
    if (onClickDot && created_at) {
      onClickDot(created_at);
    }
  };

  return (
    <svg x={cx - 12} y={cy - 12} onClick={(e) => e.stopPropagation()}>
      <circle 
        cx="12" 
        cy="12" 
        r="12"
        fill={fillColor}
        style={{ cursor: 'pointer' }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={handleClick}
      />
    </svg>
  )
};

export default CustomDot;